// extracted by mini-css-extract-plugin
export default {"app":"Terms_app__gXRTd","headerBar":"Terms_headerBar__G32qF","view":"Terms_view__TbWc3"};